var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C5.87833 0 3.84367 0.8431 2.34317 2.34317C0.843167 3.84382 0 5.87833 0 8C0 10.1217 0.8431 12.1563 2.34317 13.6568C3.84382 15.1568 5.87833 16 8 16C10.1217 16 12.1563 15.1569 13.6568 13.6568C15.1568 12.1562 16 10.1217 16 8C16 5.87833 15.1569 3.84367 13.6568 2.34317C12.1562 0.843167 10.1217 0 8 0ZM9 13.75H7V11.75H9V13.75ZM9.53515 9.1465C9.18815 9.34312 8.98112 9.71812 9 10.1166V10.25H7V10.1166C6.99154 9.54688 7.14258 8.98635 7.4349 8.49807C7.72787 8.00913 8.15105 7.612 8.6569 7.35028C9.17318 7.09833 9.50065 6.57425 9.5 6.00002C9.47917 5.18035 8.81967 4.52085 8 4.50002C7.17187 4.50002 6.5 5.17188 6.5 6.00002H4.5C4.5 5.07163 4.86848 4.18168 5.52538 3.52535C6.18163 2.86845 7.0716 2.49997 8.00005 2.49997C8.92453 2.51234 9.80805 2.88473 10.4617 3.53838C11.1154 4.19203 11.4878 5.0755 11.5001 6.00005C11.5027 6.6563 11.3198 7.30018 10.9721 7.85755C10.6245 8.41418 10.1264 8.86145 9.53528 9.14662L9.53515 9.1465Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.ff60bbe83e679357c1199c0c9b410dbe.svg";
export { ForwardRef as ReactComponent };